import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {IStore} from '../../../redux/interface';
import {ILineChartData} from '@wholesalechange/chatcomponent';
import {CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';

export const ExerciseStats: React.FunctionComponent = () => {
  const {
    exerciseStatistics
  } = useSelector((state: IStore) => state.exercise);

  const [lines, setLines] = useState<{name: string, dataKey: string}[]>([]);
  const [chartData, setChartData] = useState<any[]>([]); // eslint-disable-line @typescript-eslint/no-explicit-any
  const [colors] = useState<string[]>(['#eba378', '#5b5aa6', '#c1e6d9', '#78c7eb', '#84a58b', '#f8f0cc', '#d66027', '#f2b5d4', '#736c9f', '#a8d68f']);

  useEffect(() => {
    if (exerciseStatistics && exerciseStatistics.length) {
      const vals = exerciseStatistics
        .map(line => JSON.parse(line) as ILineChartData[])
        .flat()
        .filter(line => line.values && line.values.length)
        .slice(0, 10);

      if (vals) {
        const linesArray = vals.map((item, i) => {
          return {
            name: item.name,
            dataKey: `value${i}`
          };
        });

        setLines(linesArray);
        const dataRecord = vals.reduce((valuesDict, item, i) => {
          const newDict = {...valuesDict};

          item.values.forEach((lineData) => {
            const dictItem = {...(newDict[lineData.id] || {})};

            dictItem[`value${i}`] = lineData.value;
            dictItem.name = lineData.label || lineData.id;
            newDict[lineData.id] = dictItem;
          });

          return newDict;
        }, {} as Record<number, any>); // eslint-disable-line @typescript-eslint/no-explicit-any

        setChartData(Object.values(dataRecord));
      } else {
        setLines([]);
        setChartData([]);
      }
    }
  }, [exerciseStatistics]);

  return lines && lines.length ? <ResponsiveContainer width="100%" height={400}>
    <LineChart data={chartData}>
      <CartesianGrid strokeDasharray="3 3"/>
      <XAxis dataKey="name"/>
      <YAxis/>
      <Tooltip/>
      <Legend/>
      {lines.map((line, i) => {
        return <Line key={i} type="monotone" name={line.name} dataKey={line.dataKey} stroke={colors[i]}
          strokeWidth={2}/>;
      })}
    </LineChart>
  </ResponsiveContainer> : <></>;
};
